<template>
  <v-alert
    :value="true"
    color="primary"
    dismissible
    class="ma-0"
    style="border-radius: 0;"
  >
    <v-layout align-center justify-center>
      <div style="font-size: 1.3rem; line-height: 2rem; text-align: center;">
        <strong>Interactive Floorplans 4 Beta is here!</strong> The full release arrives January 30, 2026. Help make it great, by sharing your feedback!
        <v-btn small href="https://beta.interactivefloorplans.arizona.edu/" target="_blank" class="ml-2" style="padding-left: 16px; padding-right: 16px;">
          Go To Beta
          <v-icon small class="ml-2">open_in_new</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-alert>
</template>

<script>
export default {
  name: 'BetaAlert'
}
</script>

<style scoped>
.v-alert >>> .v-alert__dismissible {
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BetaAlert.vue